import UdeskLocales from 'UdeskLocales';

export const getTypeLabel = (type?: number) => {
    const labelMap = {
        1: /* 随路数据 */ UdeskLocales['current'].components.randomFieldSelect.utils
            .followtheroadData,
        3: /* 预处理数据 */ UdeskLocales['current'].components.randomFieldSelect.utils
            .preprocessingData,
        6: /* 业务记录 */ UdeskLocales['current'].components.randomFieldSelect.utils
            .businessRecords,
        15: /* 工单信息 */ UdeskLocales['current'].components.randomFieldSelect.utils
            .workOrderInformation,
        16: /* 客户信息 */UdeskLocales['current'].components.randomFieldSelect.utils.customerInformation,
        18: /* 随路数据 */ UdeskLocales['current'].components.randomFieldSelect.utils
            .followtheroadData,
    };

    return labelMap[type ?? ''];
};
